//This is copied from gondor
function mask(_input: string | number, showLast = 4, maskChar = '*') {
  let input = _input
  if (typeof input === 'number') {
    input = String(input)
  }
  if (typeof input !== 'string' || input.length < showLast) {
    return input
  }

  const start = input.slice(0, input.length - showLast)
  const end = input.slice(input.length - showLast, input.length)
  return start.replace(/./g, maskChar) + end
}

// Some naming inspiration from: https://www.npmjs.com/package/libphonenumber-js#country-calling-code
export function parsePhoneNumber(phoneString: string) {

  // Assume it's a US phone if no country code given.
  if (!phoneString.startsWith('+')) {
    phoneString = `+1${phoneString}`
  }

  // Remove extension if present
  const match = phoneString.match(/(.*?)(ext|x)(\d*)/)
  if (match) {
    phoneString = match[1]
  }

  // Remove everything but digits, adding the plus back in at the start.
  const number = `+${phoneString.replace(/\D/g, '')}`

  const redacted = mask(number.slice(2))

  return { number, redacted }
}
